import {
  Accordion,
  AccordionDetails,
  AccordionProps,
  AccordionSummary,
  Typography,
} from '@mui/material';
import { CaretDown } from '@phosphor-icons/react';

interface UploadItemAccordionProps extends AccordionProps {
  expanded: boolean;
  title: string;
  onExpandedToggle: VoidFunction;
}

function UploadItemAccordion({
  children,
  expanded,
  title,
  onExpandedToggle,
  ...props
}: UploadItemAccordionProps) {
  return (
    <Accordion
      expanded={expanded}
      sx={{
        backgroundColor: '#fff',

        width: '100%',
        height: 'auto !important',
        minWidth: 'auto !important',
        minHeight: 'auto !important',

        boxShadow: 'none',

        borderRadius: '1rem !important',
        borderColor: '#e4e4e7',
        borderStyle: 'solid',
        borderWidth: '1px',

        '&:hover [data-actions]': {
          display: 'block',
        },

        '&::before': {
          display: 'none',
        },
      }}
      onChange={onExpandedToggle}
      {...props}
    >
      <AccordionSummary
        expandIcon={<CaretDown size={20} />}
        sx={{
          minHeight: 'auto !important',

          '& > .MuiAccordionSummary-content': {
            position: 'relative',
            isolation: 'isolate',

            width: '100%',
            marginBlock: '0.75rem',
          },

          '& > .MuiAccordionSummary-content.Mui-expanded': {
            marginBlock: '0.75rem',
          },
        }}
      >
        <Typography variant="h4" fontSize="1rem" fontWeight={500}>
          {title}
        </Typography>
      </AccordionSummary>

      <AccordionDetails
        sx={{ '&>*+*': { marginBlockStart: '1.25rem !important' } }}
      >
        {children}
      </AccordionDetails>
    </Accordion>
  );
}

export { UploadItemAccordion };
